import PropTypes from "prop-types";
import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Divider,
  Stack,
  Typography,
  TextField,
} from "@mui/material";
import { useState } from "react";

function ConfirmationDialog(props) {
  const {
    open,
    title,
    message,
    confirmText,
    cancelText,
    onConfirm,
    onCancel,
    name,
    type,
    requirePassword = false,
    passwordLabel = "كلمة المرور",
  } = props;

  const [password, setPassword] = useState("");

  const handleClose = () => {
    setPassword("");
    onCancel();
  };

  const handleConfirm = () => {
    onConfirm(password);
    setPassword("");
  };

  return (
    <Dialog
      open={open}
      onClose={handleClose}
      maxWidth="xs"
      fullWidth
      sx={{
        direction: "ltr",
      }}
    >
      <DialogTitle>{title}</DialogTitle>
      <Divider />
      <DialogContent>
        <Stack direction="row" spacing={1} sx={{ alignItems: "center" }}>
          <Typography>{message}</Typography>
          <Typography color="error">{name}</Typography>
        </Stack>
        {requirePassword && (
          <TextField
            label={passwordLabel}
            type="password"
            fullWidth
            margin="normal"
            size="small"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            autoFocus
          />
        )}
      </DialogContent>
      <DialogActions>
        <Button onClick={handleClose} color="secondary" variant="contained">
          {cancelText}
        </Button>
        <Button
          onClick={handleConfirm}
          color={type ? "primary" : "error"}
          autoFocus
          variant="contained"
          disabled={requirePassword && password.length === 0}
        >
          {confirmText}
        </Button>
      </DialogActions>
    </Dialog>
  );
}

ConfirmationDialog.propTypes = {
  open: PropTypes.bool.isRequired,
  title: PropTypes.string.isRequired,
  message: PropTypes.string.isRequired,
  confirmText: PropTypes.string.isRequired,
  cancelText: PropTypes.string.isRequired,
  onConfirm: PropTypes.func.isRequired,
  onCancel: PropTypes.func.isRequired,
  name: PropTypes.string,
  type: PropTypes.string,
  requirePassword: PropTypes.bool,
  passwordLabel: PropTypes.string,
};

export default ConfirmationDialog;
